import { ProjectId, ServiceId, Workflow, WorkflowId, WorkflowUserSettings } from '@ply-io/ply-front-shared-utilities';

import {
	getWorkflows as getWorkflowsAction,
	changeWorkflowUserSettings as changeWorkflowUserSettingsAction,
	createWorkflow as createWorkflowAction,
	deleteWorkflow as deleteWorkflowAction,
	reset as resetAction,
	updateWorkflow as updateWorkflowAction,
} from '@/store/modules/workflows/actions';
import { useStore } from '@/utils/store';

type APIListResponse<T> = {
	count: number;
	next: URL;
	previous: URL;
	results: T[];
};
type GetWorkflowsResponsePayload = APIListResponse<Workflow>;
export interface GetWorkflowsFilter extends Record<string, unknown> {
	project: ProjectId;
	service: ServiceId[] | ServiceId;
	page_size: number;
}
type GetWorkflowsPayload = {
	page?: number;
	filterBy?: Partial<GetWorkflowsFilter>;
	autoPaginate?: boolean;
};

type WorkflowUserSettingsWithoutWorkflowId = Omit<Partial<WorkflowUserSettings>, 'workflow_id'>;
type WorkflowCreationPayload = Partial<Workflow>;
type WorkflowUpdatePayload = Partial<Workflow>;

export const useWorkflowsActions = () => {
	const { dispatch } = useStore();
	return {
		getWorkflows: (payload: GetWorkflowsPayload) => dispatch<GetWorkflowsPayload, GetWorkflowsResponsePayload>(getWorkflowsAction, payload),
		changeWorkflowUserSettings: (workflowId: WorkflowId, settings: WorkflowUserSettingsWithoutWorkflowId) =>
			dispatch<{ id: WorkflowId; settings: WorkflowUserSettingsWithoutWorkflowId }, Workflow>(changeWorkflowUserSettingsAction, {
				id: workflowId,
				settings,
			}),
		createWorkflow: (workflow: WorkflowCreationPayload) =>
			dispatch<{ workflow: WorkflowCreationPayload }, Workflow>(createWorkflowAction, { workflow }),
		deleteWorkflow: (workflowId: WorkflowId) => dispatch<{ id: WorkflowId }, void>(deleteWorkflowAction, { id: workflowId }),
		reset: () => dispatch<undefined, void>(resetAction, undefined),
		updateWorkflow: (id: WorkflowId, data: WorkflowUpdatePayload) =>
			dispatch<{ id: WorkflowId; data: WorkflowUpdatePayload }, Workflow>(updateWorkflowAction, { id, data }),
	};
};
